import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

export const OneSchemaTimesheetModalStyled = styled(Modal)({
  maxWidth: 858,
});
